export default __webpack_public_path__ + "static/media/09-Check-the-plumbing.4c6a9145.jpg";